export default "__VITE_ASSET__CZNxKEKk__"